<template>
  <div class="appt-pd-lfd px-1" :class="item.appt_pd_lfd" v-if="nonXchg">
    <el-date-picker
      v-if="item.per_diem_lfd_editable"
      size="mini"
      v-model.lazy="item.per_diem_lfd"
      type="date"
      format="MM/dd/yy"
      :value-format="'yyyy-MM-dd'"
      @change="$emit('columnEvent', 'autoSave', item, 'per_diem_lfd', $event)"
    >
    </el-date-picker>
    <div v-else>
      {{ item.per_diem_lfd_fmt }}
    </div>
  </div>
</template>

<script>
export default {
  name: "order-status-per-diem-lfd",
  props: {
    item: Object,
    options: Object,
  },
  computed: {
    nonXchg() {
      return this.item.abbrev_type != "XCHG";
    },
  },
};
</script>
